import Box from 'UIKit/Box/Box'
import Flex from 'UIKit/Box/Flex'
import Avatar from 'UIKit/Image/Avatar'
import { NextLinkFromReactRouter } from 'UIKit/NextLink'
import Text from 'UIKit/Text'
import { RouteConfig } from 'config/constants/route'
import { useUserInfo } from 'state/auth/hooks'
import { useProfileTier } from 'state/profile/hooks'
import styled from 'styled-components'
import { revalidateHunnyLevel } from 'utils'

const UserMenuAchor = () => {
  const userTier = useProfileTier()
  const { displayName, avatar } = useUserInfo()
  const displayMyTierLevel = `VIP ${revalidateHunnyLevel(userTier?.level || 0)}`

  return (
    <NextLinkFromReactRouter title="profile" to={RouteConfig.Profile}>
      <StyledContainer>
        <Box width="36px" height="36px" mr="12px">
          <Avatar src={avatar} width={100} height={100} />
        </Box>

        <Box>
          <Text fontSize="12px" fontWeight={700} letterSpacing="0.5px">
            {displayName}
          </Text>

          <Flex alignItems="flex-start" justifyContent="flex-start" mt="6px">
            <Text as="span" fontSize="10px">
              {displayMyTierLevel}
            </Text>
          </Flex>
        </Box>
      </StyledContainer>
    </NextLinkFromReactRouter>
  )
}

const StyledContainer = styled(Flex)`
  align-items: center;
  cursor: pointer;
  padding: 6px 12px;
  border-radius: ${({ theme }) => theme.radii.button};

  ${({ theme }) => theme.mediaQueries.lg} {
    &:hover {
      background: ${({ theme: { colors } }) => colors.card_primary_active};
    }
  }
`

export default UserMenuAchor
